import React from "react";
import logoitdose from "../assests/image/logoitdose.png";
const Loading = () => {
  // if (!loading) return null;
  // console.log(Changeclass);
  return (
    <div className="loading-overlay">
      <img src={logoitdose} alt="ITDOSE INFOSYSTEMS Logo" className="itdose-logo" loading="lazy" />
      <div className="loadingio-spinner-spinner-nq4q5u6dq7r">
        <div className="ldio-x2uulkbinbj">
          {[...Array(21)].map((_, index) => (
            <div key={index}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Loading;
